import { useQuery } from '@tanstack/react-query';

import { RQ_BAG_DETAILED_KEY } from '../ReactQuery/cacheKeys';
import { useCurrentLanguage } from '../language/useCurrentLanguage';
import { useCurrentUser } from '../user/useCurrentUser';

import { getBagDetailed } from './helpers';
import { type OptimisticDetailedBag } from './types';

const BAG_DETAILED_STALE_TIME = 120000; // two minutes in milliseconds

export function useBagDetailed(
  { enabled, includeOffers } = {
    enabled: true,
    includeOffers: false,
  }
) {
  const { language } = useCurrentLanguage();
  const [isAuth] = useCurrentUser();
  const query = useQuery<OptimisticDetailedBag>({
    queryKey: [RQ_BAG_DETAILED_KEY, language, includeOffers],
    enabled,
    staleTime: BAG_DETAILED_STALE_TIME,
    queryFn: async () => {
      const res = await getBagDetailed({
        isAuth,
        language,
        includeOffers,
        includeSellerSettings: false,
      });
      return res;
    },
  });

  return { query };
}
